// extracted by mini-css-extract-plugin
module.exports = {"container":"eh","hero":"fh","content":"gh","typeProd":"hh","notTransparent":"ih","sliderDots":"jh","active":"kh"};